import { apiFetch } from './client'
import type { ReportType } from '@isapi/shared'

export async function generateReport(
  type: ReportType,
  filters?: Record<string, string>
): Promise<{ report: Record<string, unknown>; rows: Record<string, unknown>[] }> {
  return apiFetch('/reports/generate', {
    method: 'POST',
    body: JSON.stringify({ type, filters }),
  })
}
